module.exports = __webpack_public_path__ + "img/rack.60d7ea22.png";